import { BusinessProfileUpdateStrategy } from '../../../../providers/BusinessProfileProvider';

export default {
  modals: {
    update_strategy: {
      title: 'Hvilke lokationer skal opdateres?',
      form: {
        update_strategy: {
          options: {
            [BusinessProfileUpdateStrategy.All]: 'Alle mine lokationer',
            [BusinessProfileUpdateStrategy.Current]: 'Kun den valgte lokation',
          },
        },
      },
      buttons: {
        confirm: 'Bekræft',
      },
    },
  },
  toasts: {
    error: 'Noget gik galt. Prøv igen, eller kontakt teknisk support',
    success: 'Ændringerne er blevet gemt!',
  },
};
